import classes from "./styles.module.scss";

export const PrivacyPolicyPage = () => {

  return (
    <div className={classes.PrivacyPolicyPage}>
      <div className={classes.contentWrapper}>
        {/* <div className={classes.logo} onClick={() => navigate("/")}>.shortform</div> */}
        <div className={classes.content}>
          <h1>Privacy Policy</h1>

          <h2>1. Information We Collect</h2>
          <p>We collect information you provide directly to us, such as when you create an account, use our services, or contact us for support. This may include your name, email address, and any content you upload or generate using our platform.</p>

          <h2>2. How We Use Your Information</h2>
          <p>We use the information we collect to provide, maintain, and improve our services, process transactions, send you technical notices and support messages, and respond to your comments and questions.</p>

          <h2>3. Information Sharing and Disclosure</h2>
          <p>We do not sell, trade, or otherwise transfer your personal information to third parties without your consent, except as described in this policy or as required by law.</p>

          <h2>4. Data Security</h2>
          <p>We implement appropriate security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the internet is 100% secure.</p>

          <h2>5. Cookies and Tracking Technologies</h2>
          <p>We use cookies and similar technologies to enhance your experience on our website, analyze usage patterns, and provide personalized content. You can control cookie settings through your browser preferences.</p>

          <h2>6. Third-Party Services</h2>
          <p>Our service may contain links to third-party websites or services that are not owned or controlled by us. We are not responsible for the privacy practices of these third parties.</p>

          <h2>7. Children's Privacy</h2>
          <p>Our services are not intended for children under 13. We do not knowingly collect personal information from children under 13. If we become aware that we have collected such information, we will take steps to delete it.</p>

          <h2>8. Changes to This Policy</h2>
          <p>We may update this privacy policy from time to time. We will notify you of any changes by posting the new policy on this page and updating the "last updated" date.</p>

          <h2>9. Contact Us</h2>
          <p>If you have any questions about this privacy policy, please contact us through our contact page.</p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
